export default class Dropdown {
    constructor(selector, options = {}) {
        this.selector = selector;
        this.options = Object.assign({}, options);
        this.init();
    }
    init() {
        for (const element of this.selector.children) {
            if (element.tagName == 'BUTTON') {
                const icon = element.firstElementChild
                const dropdownList = element.nextElementSibling

                element.addEventListener('click', (e) => {
                    icon.classList.add('rotate')
                    icon.classList.toggle('rotate-180')
                    this.toggle(dropdownList);
                })

                document.addEventListener('click', (e) => {
                    if (!this.selector.contains(e.target)) {
                        dropdownList.classList.remove('open')
                    }
                })
            }
        }
    }

    toggle = (ele) => {
        ele?.classList.toggle('open');
    }
}